import styled from 'styled-components';

const RowTableContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

interface TitleProps {
  witdh: number;
}

const RowTableTitle = styled.div<TitleProps>`
  width: ${(props) => props.witdh}px;
  background-color: #f7f8fc;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 12px;
  color: #616161;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  /* text-align: center; */
`;

const RowTableBox = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e1e2e4;
`;

const TableRowDirection = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e1e2e4;
`;

const RowHeader = styled.div`
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const r = {
  RowTableContent,
  RowTableTitle,
  RowTableBox,
  TableRowDirection,
  RowHeader,
  RowContainer,
};

export { r };
